import { GRAY_SCALE_DARK, ACCENT_DARK, SEMANTIC_COLORS, SEMANTIC_BACKGROUNDS } from './tokens/colors';
import { FONT_FAMILY, FONT_FAMILY_MONO, FONT_SIZE, FONT_WEIGHT, LINE_HEIGHT, ROLES } from './tokens/typography';
import { spacing } from './tokens/spacing';
import { BORDER_RADIUS, BORDER_WIDTH } from './tokens/borders';
import { BOX_SHADOW_DARK } from './tokens/shadows';
import { ANIMATION_DURATION, TRANSITIONS } from './tokens/animations';
import { focusShadow } from './tokens/focusShadow';

const gray = GRAY_SCALE_DARK;

// NOTE: dark mode is an acknowledged gap (see simkura-design.md known-gaps).
// This file mirrors lightTheme structurally so the type system resolves
// and the app doesn't crash if a user toggles dark; visuals will need a
// dedicated tuning pass once the light theme converges.
export const darkTheme = {
  name: 'dark',
  isDark: true,

  accent: {
    primary:    ACCENT_DARK.primary,
    secondary:  ACCENT_DARK.secondary,
    tertiary:   ACCENT_DARK.tertiary,
    quaternary: ACCENT_DARK.quaternary,
    accent10:   ACCENT_DARK.accent10,
  },

  background: {
    primary:           gray.gray1,
    secondary:         gray.gray2,
    tertiary:          gray.gray4,
    quaternary:        gray.gray5,
    invertedPrimary:   gray.gray12,
    invertedSecondary: gray.gray11,
    danger:            '#3D1F1F',
    transparent: {
      primary:   'rgba(17, 17, 17, 0.7)',
      secondary: 'rgba(17, 17, 17, 0.6)',
      strong:    'rgba(80, 80, 80, 0.5)',
      medium:    'rgba(47, 47, 47, 0.5)',
      light:     'rgba(25, 25, 25, 0.5)',
    },
  },

  border: {
    color: {
      strong:  gray.gray6,
      medium:  gray.gray5,
      light:   gray.gray4,
      danger:  '#6D2B2D',
      blue:    '#5A75D6',
    },
    radius: BORDER_RADIUS,
    width:  BORDER_WIDTH,
  },

  boxShadow: BOX_SHADOW_DARK,

  font: {
    family:     FONT_FAMILY,
    familyMono: FONT_FAMILY_MONO,
    size:       FONT_SIZE,
    weight:     FONT_WEIGHT,
    color: {
      primary:    gray.gray12,
      secondary:  gray.gray11,
      tertiary:   gray.gray9,
      light:      gray.gray8,
      extraLight: gray.gray7,
      inverted:   gray.gray1,
      danger:     SEMANTIC_COLORS.red,
    },
    lineHeight: LINE_HEIGHT,
    roles:      ROLES,
  },

  color: SEMANTIC_COLORS,
  colorBg: SEMANTIC_BACKGROUNDS,

  grayScale: gray,

  spacing,

  animation: {
    duration: ANIMATION_DURATION,
    transition: TRANSITIONS,
  },

  icon: {
    size:   { sm: 14, md: 16, lg: 20, xl: 24 },
    stroke: { sm: 1.6, md: 2, lg: 2.5 },
  },

  focusShadow,
};
